import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import style from "../../assets/css/components/Card/CardPlayer.module.css";

function CardPlayer({ idPlayer, teamColor, name, app, position, numShirt, numRegPlayer }) {
  return (
    <Link
      className={style.link}
      to={`/player/${name}-${app}`}
      state={{ idPlayer, numRegPlayer }}
    >
      <div className={style.card}>
        <p className={style.name}>{name + " " + app}</p>
        <p className={style.position}>{position}</p>
        <p className={style.numShirt} style={{ color: `${teamColor}2c` }}>
          {numShirt < 10 ? `0${numShirt}` : numShirt}
        </p>
        <div className={style.photo}>
          <FontAwesomeIcon icon={faUser} />
        </div>
      </div>
    </Link>
  );
}

export default CardPlayer;
